var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHexagon = function SvgIconHexagon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.14 1.588a1.73 1.73 0 0 1 1.721 0l7.874 4.452a1.76 1.76 0 0 1 .89 1.52v8.875h-1l1 .005a1.76 1.76 0 0 1-.89 1.52l-7.874 4.453a1.73 1.73 0 0 1-1.722 0L3.267 17.96h-.001a1.76 1.76 0 0 1-.891-1.521V7.56a1.76 1.76 0 0 1 .89-1.52l.002-.001zm8.485 14.702V7.71L12 3.398 4.375 7.71v8.58L12 20.602z",
    clipRule: "evenodd"
  })));
};
export default SvgIconHexagon;